import API from './Api';
import { USER_TOKEN, ENV } from '../constants/ConfigFileConstant';
import JobList from '../components/Protected/projet/jobList';

const UserService = {
  getToken: () => sessionStorage.getItem(USER_TOKEN),
  getTokenCleared: () => {
    const token = sessionStorage.getItem(USER_TOKEN);
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const tmp = JSON.parse(window.atob(base64));
      return tmp;
    }

    return null;
  },
  setToken: token => new Promise((resolve) => {
    // decrypt ton token, valide le et set tes datas dans le sessionStorage
    sessionStorage.setItem(USER_TOKEN, token);
    resolve();
  }),
  setEnv: env => new Promise((resolve) => {
    sessionStorage.setItem(ENV, env);
    resolve();
  }),
  auth(email, password, env) {
    return API.login(email, password).then((response) => {
      const { token } = (
        response || {}
      ).data || {};
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const tmp = JSON.parse(window.atob(base64));
      this.setEnv(env);
      return UserService.setToken(token).then(() => tmp);
    });
  },
  isUser: () => {
    const token = UserService.getTokenCleared();
    return token && token.job === JobList.USER;
  },
};


export { UserService as default };



// WEBPACK FOOTER //
// ./src/services/userService.js